import React from "react";
import { Button, Stack, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";

const StyledStack = styled(Stack)`
  flex-direction: row;
  justify-content: end;
  margin-bottom: 1.5em;
`;

const TableCreateButton = ({
  link,
}) => {
  const navigate = useNavigate();
  const onCreateButtonClicked = () => navigate(link);

  return (
    <StyledStack>
      <Button
        variant="contained"
        onClick={onCreateButtonClicked}
      >
        New
      </Button>
    </StyledStack>
  );
};

export default TableCreateButton;